export const CONDITION_TYPES = {
    EQUALS: 'equals',
    NOT_EQUALS: 'not Equals',
    LESSER: 'lesser',
    LESSER_OR_EQUAL: 'lesser or equal',
    GREATER: 'greater',
    GREATER_OR_EQUAL: 'greater or equal'
};
